import { useEffect, useState, useCallback } from "react";
import Menu from "./Menu/Menu";
import StandingCard from "./StandingCard/StandingCard";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import ErrorSoundFile from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import { useDispatch } from "react-redux";
import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function MasterWise() {
  const windowSize = useSize();
  const dispatch = useDispatch();
  const [playError] = useSound(ErrorSoundFile);

  const [loading, setLoading] = useState(true);
  const [positions, setPositions] = useState([]);

  const userType = Number(localStorage.getItem("user_type") || 7);

  // Load standing data from backend
  const loadStanding = useCallback(async () => {
    setLoading(true);

    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        master: "1",
      };

      let res = null;

      // Choose API based on user type
      if (userType === 1) {
        res = await backend.standing_admin(data);
      } else if (userType === 2) {
        res = await backend.standing_super(data);
      } else {
        toast.error("Invalid user type");
        setLoading(false);
        return;
      }

      setLoading(false);

      // Validate response
      if (res?.error === "False") {
        setPositions(res.standing || []);
        dispatch({ type: "CLEAR_PF" });
      } else {
        if (res?.logout === 1) {
          window.LogOut?.();
        } else {
          playError();
          toast.error(res?.message || "Failed to load data");
        }
      }
    } catch (err) {
      console.error("Error loading standings:", err);
      setLoading(false);
      playError();
      toast.error("Something went wrong. Please try again.");
    }
  }, [dispatch, playError, userType]);

  // Initial load
  useEffect(() => {
    loadStanding();
  }, [loadStanding]);

  // ---- UI Rendering ----
  return (
    <div>
      <Filter records={positions.length} onReload={loadStanding} />
      <Menu userType={userType} />

      <div
        style={{
          width: windowSize[0],
          height: windowSize[1] - 160,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 160} />
          </div>
        ) : positions.length > 0 ? (
          <div
            style={{
              width: windowSize[0],
              height: windowSize[1] - 160,
              overflowY: "auto",
            }}
          >
            {positions.map((item, index) => (
              <StandingCard
                key={item.id || index}
                userType={userType}
                item={item}
                index={index + 1}
              />
            ))}
          </div>
        ) : (
          <NotFound height={windowSize[1] - 160} title="Nothing here" subtext="No User Found." />
        )}
      </div>
    </div>
  );
}
